import React from "react";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const { user } = useAuth();

  React.useEffect(() => {
    if (user) {
      window.location.href = user.role === "admin" ? "/admin" : "/dashboard";
    }
  }, [user]);

  const handleGoogleLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
      {/* Left – hero */}
      <div className="relative hidden lg:block overflow-hidden" data-testid="login-hero">
        <img
          src="https://images.unsplash.com/photo-1485011151825-fa2f6224e540?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxpY2UlMjBob2NrZXklMjBhcmVuYSUyMG5pZ2h0fGVufDB8fHx8MTc3OTQ0NjcwMnww&ixlib=rb-4.1.0&q=85"
          alt="Ishall"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/70" />
        <div className="relative z-10 h-full flex flex-col justify-between p-12 text-white">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-white text-black flex items-center justify-center font-heading font-black text-xl">M</div>
            <div className="font-heading text-2xl font-black tracking-tight uppercase">Midtnorsk Hockeyliga</div>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-white/60 mb-3">Spillerpåmelding · Sesong 2026</div>
            <h1 className="font-heading text-5xl sm:text-6xl font-black uppercase leading-[0.95] tracking-tighter">
              Meld på <span className="text-white/70">spillere</span><br/>før kamp.<br/>
              <span className="text-white">Godkjenn.</span>
            </h1>
            <p className="mt-6 max-w-md text-white/70 text-base">
              Påmelding, lisenskontroll og kampoversikt for lagledere og serieledelse i Midtnorsk Hockeyliga.
            </p>
          </div>
          <div className="text-xs uppercase tracking-widest text-white/40">© {new Date().getFullYear()} — Midtnorsk Hockeyliga</div>
        </div>
      </div>

      {/* Right – login */}
      <div className="flex flex-col items-stretch justify-center bg-white px-6 sm:px-12 lg:px-20 py-12">
        <div className="max-w-md w-full mx-auto">
          <div className="text-xs uppercase tracking-[0.3em] text-neutral-500 mb-3">Innlogging</div>
          <h2 className="font-heading text-4xl sm:text-5xl font-black uppercase tracking-tighter">Logg inn</h2>
          <div className="mt-2 text-neutral-600">Bruk din inviterte Google-konto for å fortsette.</div>

          <div className="mt-10 swiss-card p-6">
            <Button
              data-testid="google-login-btn"
              onClick={handleGoogleLogin}
              className="w-full h-12 rounded-sm bg-black text-white hover:bg-neutral-800 font-heading uppercase tracking-widest text-base"
            >
              <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24"><path fill="#fff" d="M21.35 11.1H12v3.2h5.35c-.5 2.4-2.55 3.7-5.35 3.7-3.2 0-5.8-2.6-5.8-5.8s2.6-5.8 5.8-5.8c1.45 0 2.75.5 3.75 1.4l2.4-2.4C16.6 3.6 14.45 2.6 12 2.6 6.85 2.6 2.6 6.85 2.6 12s4.25 9.4 9.4 9.4c5.4 0 9.05-3.8 9.05-9.15 0-.6-.05-1.05-.1-1.15z"/></svg>
              Fortsett med Google
            </Button>
            <div className="mt-4 text-xs text-neutral-500">
              Kun inviterte epost-adresser får tilgang. Kontakt serieledelsen om du mangler invitasjon.
            </div>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-4 text-xs uppercase tracking-widest text-neutral-500">
            <div><div className="text-2xl font-heading font-black text-black">01</div>Lag & logo</div>
            <div><div className="text-2xl font-heading font-black text-black">02</div>Påmelding</div>
            <div><div className="text-2xl font-heading font-black text-black">03</div>Godkjenning</div>
          </div>

          <div className="mt-10 pt-6 border-t border-neutral-200">
            <a href="/standings" data-testid="public-standings-link" className="inline-flex items-center gap-2 text-sm font-heading uppercase tracking-widest text-black hover:underline">
              Se tabell & resultater →
            </a>
            <p className="text-xs text-neutral-500 mt-1">Åpent for alle — ingen innlogging nødvendig</p>
          </div>
        </div>
      </div>
    </div>
  );
}
